import React from "react";
import DadosBasicosDefaultFormConnected from "./DadosBasicosDefaultForm.connected";
import EscolhaParticipanteDefaultFormConnected from "./EscolhaParticipanteDefaultForm.connected";
import DadosProfissionaisDefaultFormConnected from "./DadosProfissionaisDefaultForm.connected";
import DadosEstadoCivilDefaultFormConnected from "./DadosEstadoCivilDefaultForm.connected";
import ReenquadrarOperacaoFormConnected from "../ReenquadrarOperacaoForm.connected";
import ConfirmarNovoCalculoConnected from "../ConfirmarNovoCalculo.connected";

const FluxoDefault = (props) => {
  return (
    <>
      {props.step === 0 && (
        <EscolhaParticipanteDefaultFormConnected {...props} />
      )}
      {props.step === 1 && <DadosBasicosDefaultFormConnected {...props} />}
      {props.step === 2 && (
        <DadosProfissionaisDefaultFormConnected {...props} />
      )}
      {props.step === 3 && <DadosEstadoCivilDefaultFormConnected {...props} />}
      {props.step === 995 && <ReenquadrarOperacaoFormConnected {...props} />}
      {props.step === 996 && <ConfirmarNovoCalculoConnected {...props} />}
    </>
  );
};

export default FluxoDefault;
